import store from "../store/index";

export default function auth({ next, router }) {
  if (!store.state.userLogged || store.state.userLogged.length == 0) {
    return router.push({ name: "Login" });
  }

  return next();
}
